var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const defaults = () => ({
    MODE: (typeof process !== 'undefined' && process.env && process.env.MODE) || 'primary',
    MAP_BROADCAST_URL: (typeof process !== 'undefined' && process.env && process.env.MAP_BROADCAST_URL) || '',
    REACT_APP_MAX_HISTORY_TRANSPORTS: (typeof process !== 'undefined' && process.env && process.env.REACT_APP_MAX_HISTORY_TRANSPORTS) || '1000',
    MEDIA_WEBRTC_ICE_URLS: (typeof process !== 'undefined' && process.env && process.env.MEDIA_WEBRTC_ICE_URLS) || '',
});
let runtimeEnv = defaults();
export function loadRuntimeEnv() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch('/api/public/config', { credentials: 'same-origin' });
            if (response.ok) {
                runtimeEnv = Object.assign(Object.assign({}, defaults()), (yield response.json()));
            }
        }
        catch (_a) {
            runtimeEnv = defaults();
        }
        if (typeof window !== 'undefined') {
            window.__RUNTIME_ENV__ = runtimeEnv;
        }
    });
}
export function getRuntimeEnv() {
    return runtimeEnv;
}
